import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_BRAND_SUCCESS,
  GET_ALL_BRAND_REQUEST,
  GET_ALL_BRAND_FAILURE,
} from "./ActionType";

export const getAllBrand = () => async (dispatch) => {
  dispatch({ type: GET_ALL_BRAND_REQUEST });
  try {
    const { data } = await publicAxios.get(`brands`);
    dispatch({ type: GET_ALL_BRAND_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_BRAND_FAILURE, payload: error.message });
  }
};
